"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationCreateDto = instanceOfOrientationCreateDto;
exports.OrientationCreateDtoFromJSON = OrientationCreateDtoFromJSON;
exports.OrientationCreateDtoFromJSONTyped = OrientationCreateDtoFromJSONTyped;
exports.OrientationCreateDtoToJSON = OrientationCreateDtoToJSON;
exports.OrientationCreateDtoToJSONTyped = OrientationCreateDtoToJSONTyped;
const OrientationSessionCreateDto_1 = require("./OrientationSessionCreateDto");
const StipendCreateDto_1 = require("./StipendCreateDto");
const LicenseType_1 = require("./LicenseType");
/**
 * Check if a given object implements the OrientationCreateDto interface.
 */
function instanceOfOrientationCreateDto(value) {
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('totalSeats' in value) || value['totalSeats'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('orientationSessions' in value) || value['orientationSessions'] === undefined)
        return false;
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    return true;
}
function OrientationCreateDtoFromJSON(json) {
    return OrientationCreateDtoFromJSONTyped(json, false);
}
function OrientationCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'description': json['description'] == null ? undefined : json['description'],
        'totalRate': json['totalRate'],
        'totalSeats': json['totalSeats'],
        'specialtyCode': json['specialtyCode'],
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'isSearchable': json['isSearchable'] == null ? undefined : json['isSearchable'],
        'orientationSessions': (json['orientationSessions'].map(OrientationSessionCreateDto_1.OrientationSessionCreateDtoFromJSON)),
        'facilityId': json['facilityId'],
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendCreateDto_1.StipendCreateDtoFromJSON)),
    };
}
function OrientationCreateDtoToJSON(json) {
    return OrientationCreateDtoToJSONTyped(json, false);
}
function OrientationCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'description': value['description'],
        'totalRate': value['totalRate'],
        'totalSeats': value['totalSeats'],
        'specialtyCode': value['specialtyCode'],
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'isSearchable': value['isSearchable'],
        'orientationSessions': (value['orientationSessions'].map(OrientationSessionCreateDto_1.OrientationSessionCreateDtoToJSON)),
        'facilityId': value['facilityId'],
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendCreateDto_1.StipendCreateDtoToJSON)),
    };
}
//# sourceMappingURL=OrientationCreateDto.js.map